import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import Layout from "@/components/Layout";
import ServerStatusBanner from "@/components/ServerStatusBanner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Stock from "@/pages/Stock";
import Orders from "@/pages/Orders";
import Invoices from "@/pages/Invoices";
import Irsaliyeler from "@/pages/Irsaliyeler";
import QuickSale from "@/pages/QuickSale";
import Contacts from "@/pages/Contacts";
import Quotes from "@/pages/Quotes";
import Agenda from "@/pages/Agenda";
import Kdv from "@/pages/Kdv";
import Reports from "@/pages/Reports";
import UsersPage from "@/pages/Users";
import WorkerHome from "@/pages/WorkerHome";
import Activities from "@/pages/Activities";
import Performance from "@/pages/Performance";
import Chat from "@/pages/Chat";
import PrepLists from "@/pages/PrepLists";
import Cheques from "@/pages/Cheques";
import Discounts from "@/pages/Discounts";
import KabloBulten from "@/pages/KabloBulten";
import Receipts from "@/pages/Receipts";
import TrashBin from "@/pages/Trash";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function HomeRoute() {
  const { user } = useAuth();
  return user?.role === "admin" ? <Dashboard /> : <WorkerHome />;
}

function App() {
  return (
    <div className="App">
      <ServerStatusBanner />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><HomeRoute /></Protected>} />
            <Route path="/stok" element={<Protected><Stock /></Protected>} />
            <Route path="/hizli-satis" element={<Protected><QuickSale /></Protected>} />
            <Route path="/talepler" element={<Protected><Orders /></Protected>} />
            <Route path="/alis" element={<Protected adminOnly><Invoices type="alis" /></Protected>} />
            <Route path="/satis" element={<Protected adminOnly><Invoices type="satis" variant="archive" /></Protected>} />
            <Route path="/efatura" element={<Protected adminOnly><Invoices type="satis" variant="efatura" /></Protected>} />
            <Route path="/irsaliyeler" element={<Protected adminOnly><Irsaliyeler /></Protected>} />
            <Route path="/cari" element={<Protected adminOnly><Contacts /></Protected>} />
            <Route path="/makbuz" element={<Protected adminOnly><Receipts /></Protected>} />
            <Route path="/cop-kutusu" element={<Protected adminOnly><TrashBin /></Protected>} />
            <Route path="/evraklar" element={<Protected adminOnly><Cheques /></Protected>} />
            <Route path="/teklifler" element={<Protected adminOnly><Quotes /></Protected>} />
            <Route path="/iskontolar" element={<Protected adminOnly><Discounts /></Protected>} />
            <Route path="/kablo-bulten" element={<Protected adminOnly><KabloBulten /></Protected>} />
            <Route path="/sohbet" element={<Protected><Chat /></Protected>} />
            <Route path="/hazirlik" element={<Protected><PrepLists /></Protected>} />
            <Route path="/aktiviteler" element={<Protected adminOnly><Activities /></Protected>} />
            <Route path="/performans" element={<Protected adminOnly><Performance /></Protected>} />
            <Route path="/urun-sorgu" element={<Navigate to="/stok" replace />} />
            <Route path="/ajanda" element={<Protected adminOnly><Agenda /></Protected>} />
            <Route path="/kdv" element={<Protected adminOnly><Kdv /></Protected>} />
            <Route path="/raporlar" element={<Protected adminOnly><Reports /></Protected>} />
            <Route path="/kullanicilar" element={<Protected adminOnly><UsersPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
